import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'CAR_SOURCE_PUBLISH',
    icon: 'menu-car-purchase',
    label: '车源发布',
    children: [
      {
        code: 'CAR_SOURCE_MANAGEMENT',
        icon: 'menu-default',
        label: '车源管理',
        path: '/car-source/publish',
      },
      {
        code: 'CAR_SOURCE_SHARE',
        icon: 'menu-default',
        label: '分享管理',
        path: '/car-source/share',
      },
      {
        code: 'CAR_SOURCE_TAG',
        icon: 'menu-default',
        label: '标签管理',
        path: '/car-source/tag',
      },
    ],
  },
] satisfies Menu[];
